/**
 * MIS-227/MIS-237: render a user's role for display — never a raw slug or UUID.
 *
 * `users.role` can hold a role UUID (replaceUserRole writes the id there), a legacy
 * type slug (`exec_pa`, …), or an already human-readable name. A UUID is resolved
 * against the loaded roles list; if it can't be resolved, show a dash rather than
 * leak the UUID. Slugs and plain names go through the shared label map.
 */
import { roleDisplayName } from '@shared/roleLabels';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function displayUserRole(
  role: string | null | undefined,
  roles?: ReadonlyArray<{ id: string; name: string }>,
): string {
  if (!role) return '';
  if (UUID_RE.test(role)) {
    const match = roles?.find(r => r.id === role);
    return match ? match.name : '—';
  }
  return roleDisplayName(role);
}
